import React from 'react';
import { useDev } from '../../../hooks/dev';
import styled from 'styled-components';
import { Environment } from '../../../environment';

const Wrapper = styled.div`
    top: 0;
    left: 2px;
    position: absolute;
    white-space: nowrap;
    font-size: 8px;
    padding-left: 6px;
    color: var(--x-color-text-secondary);

    &:before {
        content: '';
        height: 4px;
        width: 4px;
        left: 0;
        top: 2px;
        background-color: var(--x-color-success);
        position: absolute;
    }
`;

export function AppDev() {
    const { isDev } = useDev();

    if (!isDev) {
        return null;
    }

    return <Wrapper>{Environment.APP_VERSION}</Wrapper>;
}
